import type { CollectionCodeOperation } from './types';

/**
 * Operations that produce or target a single logical item.
 */
export const ONE_ITEM_OPERATIONS = new Set<CollectionCodeOperation>(['readOne', 'readFirst', 'createOne', 'updateOne', 'deleteOne']);

/**
 * Operations where return fields are optional rather than selected by default.
 */
export const DELETE_OPERATIONS = new Set<CollectionCodeOperation>(['deleteOne', 'deleteMany']);

/**
 * Fails fast when an operation reaches a branch that should be exhaustive.
 */
export function assertUnsupportedOperation(operation: never): never {
	throw new Error(`Unsupported collection code operation: ${operation}`);
}
